<template lang="pug">
#app
  .wrapper
    Loading
    Header
    router-view
    Footer
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
export default {
  methods:{
    buildListeners(){
      $(window).bind('resize', onResizeHandler);
      onResizeHandler();

      function onResizeHandler(){

        const root = document.documentElement;
        root.style.setProperty('--vw', `${$('.wrapper').width()>1920 ? 1920 : $('.wrapper').width()}px`);
      }

    }
  },
  mounted(){
    this.buildListeners();
  },
  components: {
    Header,
    Footer,
    Loading
  },
};
</script>

<style lang="scss">
@import '~m5att-sass-mixins/mixin';
@import '~m5att-sass-mixins/extend';
@import 'utils/sass/function';
@import 'utils/sass/mixin';

body {
  font-family: "Roboto";
}

.wrapper {
  position: relative;
  width:100%; overflow: hidden;
}

section .container {
  max-width:1200px;
}

h3 {
  font-size: md(36); font-weight: normal;
  @include _break(992px){
    font-size: 36px;
  }
}

p {
  font-size: md(20); line-height: 1.5;
  @include _break(992px){
    font-size: 18px;
  }
}

.ez-btn {
    line-height: md(48); height: md(48);
    border-radius:md(24);
    background:#4A6EE4;
    border:1px solid #4A6EE4;
    font-size: md(20); font-weight: 400; color:#fff; text-decoration: none;
    text-align: center;
    display: block;

    &:hover {
      background:#fff;
      color:#4A6EE4;
      text-decoration: none;
    }

    @include _break(992px){
      line-height: 48px; height: 48px;
      border-radius:24px;
      font-weight: normal;
      font-size: 18px;
      transition:all .4s;
    }

    &.white {
      background:#fff;
      color:#4A6EE4;
      &:hover {
        text-decoration: underline;
      }
    }
}

.ez-link {
  font-size: 20px; color:#fff; text-decoration: underline;
  &:hover {
    text-decoration: none;
    color:#fff;
  }
}

.ez-img-full {
  @include _break(992px){
    width:100vw;
    max-width:none;
  }
}
</style>

